<template>
    <div class="form-field form-autocomplete form-countries" :rel="name" v-bind:class="{'form-required': requiredForm}">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">

                <component-multiselect v-model="internalValue"
                                       :show-labels="false"
                                       label="name"
                                       track-by="id"
                                       value="String"
                                       placeholder=""
                                       :options="$store.state.countries"
                                       :multiple="isMultiple"
                                       :internal-search="true"
                                       :clear-on-select="!isMultiple"
                                       :close-on-select="!isMultiple"
                                       :show-no-results="true"
                                       :hide-selected="true"
                                       _options="$store.state.countriesGrouped"
                                       _group-values="values"
                                       _group-label="region"
                                       _group-select="true"
                                       :custom-label="nameWithRegion">

                    <template slot="option" slot-scope="props">
                        <div class="option__container" v-if="!props.option['$groupLabel']">
                            <span class="option__image"><img :src="'/src/assets/flags/'+props.option.id+'.svg'"></span>
                            <span class="option__title">{{ props.option.name }}</span>
                            <span class="option__small">{{ props.option.region }}</span>
                        </div>
                        <div class="option__container" v-if="props.option['$groupLabel']">
                            <span class="option__group_title">{{ props.option["$groupLabel"] }}</span>
                        </div>
                    </template>

                </component-multiselect>


                <button class="bt-remove" @click="removeAll()"><i class="icon icon-icon_close"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormField',
        props: ['value','label','name','placeholder','multiple', 'default','options','callback','required'],
        data: function () {
            return {
                internalValue: ''
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.isMultiple = this.multiple == 'true' ? true : false;
            this.onChange = this.callback ? true : false;
            this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false

            console.log('$store.state.countriesGrouped', this.$store.state.countriesGrouped)

        },
        methods: {
            nameWithRegion ({ name, region }) {
                return `${name}, ${region}`
            },
            addTag (newTag) {
                const tag = {
                    name: newTag,
                    code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
                }
                this.options.push(tag)
                this.value.push(tag)
            },
            removeAll: function(){
                this.internalValue = []
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'default'(newVal, oldVal) {
                if( newVal && this.options){
                    for (let item of this.options) {
                        if( item.id && item.id.toString().toLowerCase() == newVal.toString().toLowerCase() ){
                            this.internalValue = item;
                        }
                    }
                }
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
                if( this.onChange ){
                    this.callback(this.internalValue)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Countries.vue